import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/sns/Instagram.png'


const _hoisted_1 = { class: "flex border-b border-zinc-200 justify-between py-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex space-x-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "instagram logo",
    class: "w-6 h-6 m-auto object-contain"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-base font-bold table-cell align-middle" }, "Instagram")
  ])
], -1)
const _hoisted_3 = {
  key: 1,
  class: "px-7 py-3 bg-green-show text-white rounded-md text-sm font-bold"
}
const _hoisted_4 = {
  key: 2,
  class: "px-6 py-3 bg-green-show text-white rounded-md text-sm font-bold"
}
const _hoisted_5 = {
  key: 3,
  class: "px-6 py-3 bg-green-show text-white rounded-md text-sm font-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.instagramAuthentication().isNotStarted)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "px-6 py-3 bg-transparent border border-green-show text-green-show rounded-md text-sm font-bold",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goInstagramAuth()))
            }, " 連携する "))
          : (_ctx.instagramAuthentication().isInProgress)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 審査中 "))
            : (_ctx.instagramAuthentication().isFailed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 結果NG "))
              : (_ctx.instagramAuthentication().isDone)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 連携済み "))
                : _createCommentVNode("", true)
      ])
    ])
  ]))
}